/**
 * Toast stack — prototype template lines 1269-1273 (INVENTORY §2 row 10).
 *
 * Always mounted by `App.tsx`; there is nothing to wire up. Fire a toast from
 * anywhere with the store action:
 *
 *   useQd.getState().toast('ADDED TO GAMES TONIGHT?')        // success, --acc
 *   useQd.getState().toast('CURRENT PASSWORD IS WRONG', true) // error, --acc2
 *
 * The 2600 ms auto-dismiss lives in `store/slices/toasts.ts` (`TOAST_MS`), and
 * the slice already models `{ id, msg, bd }` with `bd` pre-resolved to the
 * right accent — this component never decides colour.
 *
 * Geometry is frozen: fixed, centred, `bottom:90px` (clears the 82px bottom
 * nav), `z-index:100`, `max-width:402px`, `pointer-events:none`,
 * `animation:gt-toast .18s ease-out` (keyframes in `styles/app.css`).
 */

import { useQd } from '../store/index.ts';

export function ToastHost() {
  const toasts = useQd((s) => s.toasts);
  return (
    <div
      style={{
        position: 'fixed',
        left: '50%',
        transform: 'translateX(-50%)',
        bottom: '90px',
        zIndex: 100,
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        alignItems: 'center',
        pointerEvents: 'none',
        width: '100%',
        maxWidth: '402px',
        padding: '0 14px',
        boxSizing: 'border-box',
      }}
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          style={{
            background: 'var(--gt-card)',
            border: '1px solid ' + t.bd,
            boxShadow: 'var(--gt-shadow-toast)',
            padding: '10px 14px',
            fontFamily: 'var(--gt-font-mono)',
            fontSize: '10.5px',
            color: 'var(--gt-text)',
            animation: 'gt-toast .18s ease-out',
            textAlign: 'center',
          }}
        >
          <span>{t.msg}</span>
        </div>
      ))}
    </div>
  );
}
